<template>
  <span v-if="stock && (stock.noGraph || stock.status === 2)">
    <b-button class="alert-tooltip"
              :id="stock.symbol + randomNum"
              variant="link">
      <img src="../assets/images/portfolio-tracker/alert-icon.svg"
           alt="notification icon" />
    </b-button>
    <b-tooltip :target="() => stock.symbol + randomNum"
               :title="notificationTitle"
               triggers="hover focus click">
    </b-tooltip>
  </span>
</template>
<script>
export default {
  props: {
    stock: {
      required: true
    }
  },
  data () {
    return {
      randomNum: Math.floor(Math.random() * 1000)
    }
  },
  computed: {
    notificationTitle: function () {
      if (this.stock.noGraph) {
        return 'This stock has no data to display on the graph.'
      } else if (this.stock.status === 2) {
        return this.stock.closeddate ? `This position was closed as of ${this.stock.closeddate}.` : 'This position is closed.'
      } else {
        return ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.alert-tooltip {
  padding: 0;
  margin-left: 10px;
  margin-top: -2px;
}
</style>
